(function(){
  var slider=document.getElementById('baSlider');
  if(!slider) return;
  var before=document.getElementById('baBefore');
  var divider=document.getElementById('baDivider');
  var bimg=before.querySelector('img');
  var pos=0.5;
  function fit(){ bimg.style.width=slider.clientWidth+'px'; }
  function set(p){ p=Math.max(0,Math.min(1,p)); pos=p; before.style.width=(p*100)+'%'; divider.style.left=(p*100)+'%'; divider.setAttribute('aria-valuenow', Math.round(p*100)); }
  function fromX(x){ var r=slider.getBoundingClientRect(); set((x-r.left)/r.width); }
  var dragging=false;
  slider.addEventListener('pointerdown',function(e){ dragging=true; fromX(e.clientX); e.preventDefault(); });
  document.addEventListener('pointermove',function(e){ if(dragging) fromX(e.clientX); });
  document.addEventListener('pointerup',function(){ dragging=false; });
  window.addEventListener('resize',fit);
  /* Accessibilite clavier (curseur avant/apres). Cote theme : a fournir en natif avec role=slider. */
  divider.setAttribute('role','slider');
  divider.setAttribute('tabindex','0');
  divider.setAttribute('aria-label','Comparateur avant et apres : ajustez avec les fleches du clavier');
  divider.setAttribute('aria-valuemin','0');
  divider.setAttribute('aria-valuemax','100');
  divider.setAttribute('aria-orientation','horizontal');
  divider.addEventListener('keydown',function(e){
    var step=0.05, big=0.1, k=e.key, handled=true;
    if(k==='ArrowLeft'||k==='ArrowDown'){ set(pos-step); }
    else if(k==='ArrowRight'||k==='ArrowUp'){ set(pos+step); }
    else if(k==='PageDown'){ set(pos-big); }
    else if(k==='PageUp'){ set(pos+big); }
    else if(k==='Home'){ set(0); }
    else if(k==='End'){ set(1); }
    else { handled=false; }
    if(handled){ e.preventDefault(); }
  });
  var imgEl=slider.querySelector('.ba-after');
  if(imgEl.complete){ fit(); set(0.5); } else { imgEl.addEventListener('load',function(){ fit(); set(0.5); }); }
})();
